<template>
    <Layout :isLogin="true">
        <div slot="epassport">
            <iframe
                ref="iframe"
                :src="iframeUrl"
            ></iframe>
        </div>
    </Layout>
</template>

<script>
import { sdk } from 'data';

const IFRAME_URL = sdk('SIGNUP');
export default {
    data() {
        return {
            IFRAME_URL,
            iframeUrl: `${IFRAME_URL}&feconfig=com.sankuai.malljiemo.vss`,
        };
    },
};
</script>
